var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6826_23714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6749 13.243C17.1448 14.4967 16.3156 15.6015 15.2598 16.4607C14.2041 17.32 12.9539 17.9075 11.6186 18.172C10.2833 18.4364 8.90361 18.3698 7.60005 17.9778C6.29649 17.5858 5.10878 16.8805 4.14078 15.9235C3.17277 14.9665 2.45394 13.7869 2.04712 12.4879C1.64031 11.1889 1.5579 9.81004 1.80709 8.47183C2.05629 7.13362 2.62951 5.87683 3.47663 4.81133C4.32376 3.74583 5.419 2.90407 6.6666 2.35964M18.3333 10.0013C18.3333 8.90695 18.1177 7.82332 17.6989 6.81227C17.2801 5.80123 16.6663 4.88257 15.8925 4.10875C15.1187 3.33492 14.2 2.7211 13.189 2.30231C12.1779 1.88352 11.0943 1.66797 9.99993 1.66797V10.0013H18.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6826_23714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPptx);
export default __webpack_public_path__ + "static/media/icon-pptx.d04ac337d3779d25874d05cb57d9cdea.svg";
export { ForwardRef as ReactComponent };